import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { ClientId } from "../../Types";
import ValidationError from "../../ZodError";
export const url = (clientId, familialRelationId) => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/entity/client/${clientId}/familial-relation/${familialRelationId}`
        : `https://middleware.uat.farther.com/entity/client/${clientId}/familial-relation/${familialRelationId}`;
};
export const familialRelationKeyMaker = (clientId, familialRelationId) => [
    `familialRelation-client-${clientId}-relation-${familialRelationId}`,
];
export const GetResponseBodySchema = z.object({
    clientIds: z.array(ClientId),
});
export const getFamilialRelation = async (clientId, familialRelationId, config) => {
    const { data } = await axios.get(url(clientId, familialRelationId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            ...("clientId" in config && { Client: config.clientId }),
            ...("advisorId" in config && { Advisor: config.advisorId }),
            Version: "20241030",
        },
    });
    const decoded = GetResponseBodySchema.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `[getFamilialRelation] Could not parse`;
        errorLog(errorMessage, JSON.stringify(decoded.error.issues));
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
//# sourceMappingURL=getFamilialRelation.js.map